export const LANG_EN_NAME = 'en';

export let LANG_EN_TRANS = { 
    'Report & Analysis': 'Report & Analysis',
    'Profile': 'Profile',
    'EFFICIENCY': 'EFFICIENCY',
    'Customer' : 'Customer'
};